import React from 'react';
import { Stack } from 'expo-router';

import { useModalStackOptions } from '../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function ModalsLayout() {
  const options = useModalStackOptions();

  return (
    <Stack screenOptions={options.Stack}>
      <Stack.Screen
        name="(customization)/[restaurantSlug]/[productSlug]/index"
        options={options.Customization}
      />
      <Stack.Screen
        name="(customization)/[restaurantSlug]/[productSlug]/edit/[lineItemId]/index"
        options={options.Customization}
      />
      <Stack.Screen
        name="(customization)/customize/[baseProductSlug]/index"
        options={options.Customization}
      />
      <Stack.Screen name="add-gift-card/index" options={options.AddGiftCard} />
      <Stack.Screen name="add-gift-card/[giftCardId]/index" options={options.AddGiftCard} />
      <Stack.Screen name="bag/index" options={options.Bag} />
      <Stack.Screen name="ca-data-requests/index" options={options.CaDataRequests} />
      <Stack.Screen name="chat/index" options={options.Chat} />
      <Stack.Screen name="credit/add/index" options={options.CreditAdd} />
      <Stack.Screen name="credit/index" options={options.Credit} />
      <Stack.Screen
        name="(customization)/delivery/[addressId]/[productSlug]/index"
        options={options.DeliveryCustomization}
      />
      <Stack.Screen
        name="(customization)/delivery/[addressId]/[productSlug]/edit/[lineItemId]/index"
        options={options.DeliveryCustomization}
      />
      <Stack.Screen name="delivery-order-in-flight/index" options={options.DeliveryOrderInFlight} />
      <Stack.Screen name="dietary-restrictions/index" options={options.DietaryRestrictions} />
      <Stack.Screen name="feedback/[orderId]/index" options={options.Feedback} />
      <Stack.Screen name="forgot-to-scan/index" options={options.ForgotToScan as any} />
      <Stack.Screen name="g/[joinCode]/index" options={options.GroupOrderJoin} />
      <Stack.Screen name="group-ordering/create/index" options={options.GroupOrderSetup} />
      <Stack.Screen
        name="group-ordering/create/search-location/index"
        options={options.GroupOrderSearchLocation}
      />
      <Stack.Screen name="group-ordering/share/index" options={options.GroupOrderShare} />
      <Stack.Screen name="location-selection/index" options={options.LocationSelection} />
      <Stack.Screen name="loyalty/index" options={options.Loyalty} />
      <Stack.Screen
        name="order-product/[productSlug]/confirm-location/index"
        options={options.OrderProduct}
      />
      <Stack.Screen name="order-product/[productSlug]/index" options={options.OrderProduct} />
      <Stack.Screen
        name="order-product/[productSlug]/search-location/index"
        options={options.OrderProduct}
      />
      <Stack.Screen name="order-status/[orderId]/index" options={options.OrderStatus} />
      <Stack.Screen name="personal-data-details/index" options={options.PersonalData} />
      <Stack.Screen
        name="product-details/[baseProductSlug]/index"
        options={options.ProductDetails}
      />
      <Stack.Screen name="quick-add/[baseProductSlug]/index" options={options.QuickAdd} />
      <Stack.Screen
        name="quick-add/[baseProductSlug]/search-location/index"
        options={options.QuickAddLocationSearch}
      />
      <Stack.Screen name="redeem-gift-card/index" options={options.RedeemGiftCard} />
      <Stack.Screen name="redeem-gift-card/[giftCardId]/index" options={options.RedeemGiftCard} />
      <Stack.Screen name="reorder/index" options={options.Reorder} />
      <Stack.Screen name="reorder-active-bag-warning/index" options={options.ReorderSubScreen} />
      <Stack.Screen name="reorder-change-location/index" options={options.ReorderSubScreen} />
      <Stack.Screen name="reorder-confirm-location/index" options={options.ReorderSubScreen} />
      <Stack.Screen name="reorder-conflict-review/index" options={options.ReorderSubScreen} />
      <Stack.Screen name="share/[lineItemSlug]/index" options={options.ShareLineItem} />
      <Stack.Screen
        name="share/[lineItemSlug]/search-location/index"
        options={options.ShareLineItemLocationSearch}
      />
      <Stack.Screen name="upsell/index" options={options.Upsell} />
      <Stack.Screen name="payments/index" options={options.Payments} />
      <Stack.Screen name="receipt/[receiptId]/index" options={options.Receipt} />
      <Stack.Screen name="receipt/claim/[receiptId]/index" options={options.ClaimReceipt} />
      <Stack.Screen name="hsa-fsa/index" options={options.HsaFsa} />
    </Stack>
  );
}
